export default __webpack_public_path__ + "static/media/Zahl-4.493877bc.webp";